import { Component, type ReactNode } from 'react';

interface NewTaskFormBoundaryProps {
    resetKey: string;
    fallback: ReactNode;
    children: ReactNode;
}

interface NewTaskFormBoundaryState {
    hasError: boolean;
}

/** Тримає падіння DOM (insertBefore) всередині панелі, а не на екрані роутера. */
class NewTaskFormBoundary extends Component<NewTaskFormBoundaryProps, NewTaskFormBoundaryState> {
    state: NewTaskFormBoundaryState = { hasError: false };

    static getDerivedStateFromError(): NewTaskFormBoundaryState {
        return { hasError: true };
    }

    componentDidUpdate(prevProps: NewTaskFormBoundaryProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) return this.props.fallback;
        return this.props.children;
    }
}

export default NewTaskFormBoundary;
